import React, { useEffect } from "react";
import Topbar from "../Topbar";
import Header from "../Header";
import Footer from "../Footer";
import Cookie from "../Cookie";
import ContactFooter from "../ContactFooter";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import HubspotChat from "../HubspotChat";
import AOS from "aos";
import ScrollBackToTopButton from "../ScrollBackToTopButton";

export default function BasicLayout({
  children,
  alternateLinks,
  removeLanguages,
}) {
  const [reloadCookie, setReloadCookie] = React.useState(false);

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <React.Fragment>
      <GatsbySeo
        metaTags={[
          {
            name: "msvalidate.01",
            content: "A8B938E9522BB2B41F5CAE5CD8EB7E13",
          },
          {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0",
          },
          {
            name: "author",
            content: "Line Up Handels GmbH",
          },
          {
            name: "mobile-web-app-capable",
            content: "yes",
          },
          {
            name: "apple-mobile-web-app-capable",
            content: "yes",
          },
          {
            name: "apple-mobile-web-app-status-bar-style",
            content: "default",
          },
          {
            name: "copyrightYear",
            content: "2024",
          },
          {
            name: "copyrightHolder",
            content: "Line Up Handels GmbH",
          },
          {
            name: "isFamilyFriendly",
            content: "true",
          },
          {
            name: "copyrightYear",
            content: "2024",
          },
        ]}
      />
      <Cookie reloadCookie={reloadCookie} setReloadCookie={setReloadCookie} />
      <Topbar
        alternateLinks={alternateLinks ? alternateLinks : false}
        removeLanguages={removeLanguages ? removeLanguages : false}
      />
      <Header
        navbar={true}
        alternateLinks={alternateLinks ? alternateLinks : false}
        removeLanguages={removeLanguages ? removeLanguages : false}
      />
      <div className="body">{children}</div>

      <ContactFooter />
      <HubspotChat />
      <Footer reloadCookie={reloadCookie} setReloadCookie={setReloadCookie} />
      <ScrollBackToTopButton />
    </React.Fragment>
  );
}
